import type { IValidator } from './IValidator';

export class NotEmptyValidator implements IValidator {
    status: string = '';
    statusType: 'info' | 'warning' | 'error' | 'na' = 'error';
    value?: string;
    required: boolean = false;
    public constructor() {}

    Status(): string {
        return this.status;
    }

    StatusType(): 'info' | 'warning' | 'error' | 'na' {
        return this.statusType;
    }

    Value(): string {
        return this.value as string;
    }

    Validate(cellvalue: string): boolean {
        if (cellvalue.trim() === '') {
            this.status = 'notemptyvalidator.empty';
            this.statusType = 'error';
            return false;
        }
        return true;
    }
}
